import * as R from 'radash'
import { match } from 'ts-pattern'
import { UAParser } from 'ua-parser-js'

import { Order, Schema as Schema_ } from '@blade/std-lib'

import type { UserApi } from '@root/shared/api'

const DeviceTypeSchema = Schema_.Union([
  Schema_.Literal('mobile'),
  Schema_.Literal('desktop'),
  Schema_.Literal('tablet'),
  Schema_.Literal('unknown'),
])

export type DeviceType = Schema_.Schema.Type<typeof DeviceTypeSchema>

export const Schema = Schema_.Struct({
  current: Schema_.Boolean,
  ip: Schema_.String,
  os: Schema_.Union([Schema_.String, Schema_.Undefined]),
  browser: Schema_.Union([Schema_.String, Schema_.Undefined]),
  lastLogin: Schema_.DateFromString,
  deviceType: DeviceTypeSchema,
})
export const CodecJson = Schema_.toCodecJson(Schema)

export interface Session extends Schema_.Schema.Type<typeof Schema> {}

export const fromDto = (dto: UserApi.SessionInfoDto): Session => {
  return {
    browser: dto.browser,
    current: dto.isCurrentSession,
    ip: dto.ip,
    lastLogin: new Date(dto.lastActive),
    os: dto.os,
    deviceType: parseDevice(dto),
  }
}

const parseDevice = R.memo(
  (dto: UserApi.SessionInfoDto): DeviceType => {
    if (!dto.userAgent) {
      return 'unknown'
    }
    const uaInfo = UAParser(dto.userAgent)

    return match(uaInfo.device.type)
      .returnType<DeviceType>()
      .with('mobile', () => 'mobile')
      .with('tablet', () => 'tablet')
      .with(undefined, () => 'desktop')
      .otherwise(() => 'unknown')
  },
  {
    key: (dto) => dto.userAgent ?? '',
    ttl: Infinity,
  },
)

const getLastLogin = (session: Session) => session.lastLogin
export const cmpByLastLogin = Order.mapInput(Order.Date, getLastLogin)
export const cmpByLastLoginDesc = Order.flip(cmpByLastLogin)
